import { SaveButton } from "@/components/admin";
import { Card } from "@/components/ui/card";
import { Calculator } from "lucide-react";
import {
  BooleanInput,
  Create,
  NumberInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "../../common";

const typeChoices = [
  { id: "earning", name: "Earning" },
  { id: "deduction", name: "Deduction" },
];
const calculationChoices = [
  { id: "fixed", name: "Fixed" },
  { id: "percent_of_basic", name: "Percent of Basic" },
  { id: "formula", name: "Formula" },
];

const ComponentToolbar = () => (
  <div className="form-toolbar-premium">
    <SaveButton className="btn-green-action" label="Save Component" />
  </div>
);

export const PayrollComponentCreate = () => (
  <Create title="Create Payroll Component">
    <Card className="form-container">
      <div className="form-header-premium">
        <Calculator className="w-6 h-6 text-emerald-600" />
        <h2 className="text-2xl font-bold text-slate-900">New Payroll Component</h2>
      </div>
      <SimpleForm toolbar={<ComponentToolbar />}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <TextInput source="code" label="Component Code" />
          <TextInput source="name" label="Component Name" />
          <SelectInput source="type" choices={typeChoices} defaultValue="earning" />
          <SelectInput
            source="calculation"
            choices={calculationChoices}
            defaultValue="fixed"
          />
          <NumberInput source="value" defaultValue={0} label="Value / Percentage" />
          <NumberInput source="sort_order" defaultValue={0} label="Display Order" />
        </div>
        <div className="mt-4">
          <BooleanInput source="taxable" defaultValue label="Is Taxable?" />
        </div>
      </SimpleForm>
    </Card>
  </Create>
);
